import {createContext, useContext} from "react";
import type {User} from "@vesta/vos-types/modules/workspaceLevel/users/domain/User";

type WorkspaceUsersContextData = Array<User>;

export const WorkspaceUsersContext = createContext<WorkspaceUsersContextData | undefined>(undefined);

export function useWorkspaceUsers(): WorkspaceUsersContextData {
    const workspaceUsersContextData = useContext(WorkspaceUsersContext);
    if (workspaceUsersContextData === undefined) {
        throw new Error("WorkspaceUsersContext.Provider not found");
    }

    return workspaceUsersContextData;
}

export const useUsers = useWorkspaceUsers;
